import { z } from "zod"

export const STAFF_NOTIFICATION_TYPES = ["lab_review_staff_alert", "telehealth_no_slots_staff_alert"] as const
export const StaffNotificationTypeSchema = z.enum(STAFF_NOTIFICATION_TYPES)
export const STAFF_NOTIFICATION_ROLE_KEYS = ["super_admin", "support_manager", "support_staff"] as const
export const StaffNotificationRoleKeySchema = z.enum(STAFF_NOTIFICATION_ROLE_KEYS)

export const UpdateStaffNotificationRouteSchema = z.object({
	roleKeys: z.array(StaffNotificationRoleKeySchema).refine(
		(roleKeys) => new Set(roleKeys).size === roleKeys.length,
		"Staff roles must be unique",
	),
	includeSupportInbox: z.boolean(),
}).superRefine((value, context) => {
	if (value.roleKeys.length === 0 && !value.includeSupportInbox) {
		context.addIssue({ code: "custom", message: "Select at least one staff role or the support inbox", path: ["roleKeys"] })
	}
})

export const StaffNotificationRouteSchema = z.object({
	notificationType: StaffNotificationTypeSchema,
	label: z.string(),
	description: z.string(),
	roleKeys: z.array(StaffNotificationRoleKeySchema),
	includeSupportInbox: z.boolean(),
	isDefault: z.boolean(),
})

export const StaffNotificationRoutingResponseSchema = z.object({
	routes: z.array(StaffNotificationRouteSchema),
	roles: z.array(z.object({ roleKey: StaffNotificationRoleKeySchema, label: z.string() })),
	supportEmail: z.email(),
})

export type StaffNotificationType = z.infer<typeof StaffNotificationTypeSchema>
export type StaffNotificationRoleKey = z.infer<typeof StaffNotificationRoleKeySchema>
export type UpdateStaffNotificationRoute = z.infer<typeof UpdateStaffNotificationRouteSchema>
export type StaffNotificationRoute = z.infer<typeof StaffNotificationRouteSchema>
export type StaffNotificationRoutingResponse = z.infer<typeof StaffNotificationRoutingResponseSchema>
